module.exports = __webpack_public_path__ + "img/video.9aab4e98.png";